module.exports = __webpack_public_path__ + "static/hackathon-68894f18f0af4c1487e553612fd472db.jpg";